import type { WorkshopIdea } from "@/types/workshop.type";

/**
 * The chat message asking the Workshop to expand a saved idea into its
 * production brief. Pasted into the composer, never auto-sent: the user reads
 * it, adds any direction of their own, and sends it.
 *
 * Names the tools the chat has for this, the way trends' `recreatePrompt` names
 * SaveConceptIdea — the id lets it load the exact idea rather than guess by title.
 */
export function expandIdeaToBriefPrompt(idea: Pick<WorkshopIdea, "id" | "title">): string {
  return [
    `Expand the concept idea "${idea.title}" into its production brief.`,
    `Idea id: ${idea.id} — load it with GetConceptIdea first.`,
    "Keep its angle, hooks, channels and format, ground brand details with QueryBrandDNA,",
    "then write the full brief with SaveConceptBrief.",
  ].join("\n");
}
